/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BehavioralAssessmentCto } from '../../models/behavioral-assessment-cto';

export interface UpdateBehavioralAssessment$Json$Params {
  behavioralAssessmentId: string;
  SessionGuid?: string;
  IsDeleted?: boolean;
  SurveyUserIsDeleted?: boolean;
  SurveyIsDeleted?: boolean;
}

export function updateBehavioralAssessment$Json(http: HttpClient, rootUrl: string, params: UpdateBehavioralAssessment$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<BehavioralAssessmentCto>> {
  const rb = new RequestBuilder(rootUrl, updateBehavioralAssessment$Json.PATH, 'put');
  if (params) {
    rb.path('behavioralAssessmentId', params.behavioralAssessmentId, {});
    rb.query('SessionGuid', params.SessionGuid, {});
    rb.query('IsDeleted', params.IsDeleted, {});
    rb.query('SurveyUserIsDeleted', params.SurveyUserIsDeleted, {});
    rb.query('SurveyIsDeleted', params.SurveyIsDeleted, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BehavioralAssessmentCto>;
    })
  );
}

updateBehavioralAssessment$Json.PATH = '/behavioralAssessment/{behavioralAssessmentId}';
